<template>
  <section class="form-list">

    <div class="form form-large">
      <div
          v-show="isAdministrator && !storeId"
          class="loading-box"
      >
        <el-form
            class="loading-form"
            label-position="left"
            label-width="80px"
        >
          <el-form-item v-if="isAdministrator" label="所属门店">
            <v-select-store v-model="storeId"/>
          </el-form-item>
        </el-form>
      </div>

      <div v-show="storeId">
        <el-form
            ref="form"
            label-position="left"
            label-width="160px"
            class="form-box"
        >
          <el-form-item v-if="isAdministrator" label="所属门店">
            <v-select-store v-model="storeId"/>
          </el-form-item>
        </el-form>

        <div v-for="cardType in cardTypes" :key="`cardType${cardType.card_type_name}`" class="table-box">
          <h3 class="table-title">{{ cardType.card_type_name }}绩效设置</h3>
          <el-table
              :data="cardType.salaries"
              class="income-table"
              border
              fit
              highlight-current-row
          >
            <el-table-column label="阶段" align="center">
              <template v-slot="{ $index }">
                第 {{ $index + 1 }} 阶段
              </template>
            </el-table-column>
            <el-table-column label="绩效" align="center">
              <template v-slot="{ row }">
                {{ row.salary }} 元
              </template>
            </el-table-column>

            <el-table-column label="人数" align="center">
              <template v-slot="{ $index, row }">
                <div class="flex-align-center">
                  <v-input-number
                      v-model="row.min_number"
                      :min="$index > 0 ? cardType.salaries[$index - 1].min_number : 1"
                      :max="99"
                      :is-show-suffix="true"
                      suffix-name="人"
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
            >
              <template v-slot="{ $index, row }">
                <el-popover placement="top" v-model="row.showTip">
                  <p>确认要删除吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="row.showTip = false">取消</el-button>
                    <el-button
                        type="primary"
                        size="mini"
                        @click="handleDelete($index, cardType)"
                    >
                      确认
                    </el-button>
                  </div>
                  <template slot="reference">
                    <el-button class="edit-button" size="mini" type="danger">删除</el-button>
                  </template>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <el-button class="add-button" type="primary" @click="addSalaries(cardType)">新增一项</el-button>
        </div>

        <div class="submit-button-box">
          <el-button type="primary" @click="handleSubmit" :loading="isSaving">保存设置</el-button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import RouteConfig from "@/router/config";
import { mapGetters } from 'vuex';
import {
  getStoreCardTypes,
  getStoreTeacherLadderSalaries,
  updateTeacherLadderSalaries
} from '@/api/store';
import { multipliedBy, dividedBy } from '@/utils/number';

export default {
  name: RouteConfig.teacherStageSalaryEdit.name,
  data: () => ({
    isSaving: false,
    cardTypes: [],
    storeId: 0,
    defaultCardTypes: [],
  }),
  watch: {
    storeId() {
      this.getList();
    },
  },
  computed: {
    ...mapGetters([
      'isAdministrator',
      'isManagerOrReceptionist',
      'userStoreId',
    ]),
  },
  beforeMount() {
    if (this.isAdministrator) this.storeId = 1;
    if (this.isManagerOrReceptionist) {
      this.storeId = this.userStoreId;
      this.getList();
    }
    this.getCardTypes();
  },
  methods: {
    getMinNumber(salaries, index) {
      let minNumber = index === 0 ? 1 : salaries[index - 1].min_number + 1;
      if (minNumber > 99) minNumber = 99;

      return minNumber;
    },
    addSalaries({ id, salaries }) {
      const length = salaries.length;
      const min_number = length === 0 ? 1 : this.getMinNumber(salaries, length);

      let salary = 0;
      this.defaultCardTypes.some(item => {
        if (item.id !== id) return false;
        if (!item || !item.salaries || item.salaries.length === 0) return false;

        const currentSalary = item.salaries[length];
        if (currentSalary) {
          salary = currentSalary.salary;
          return true;
        }

        const lastSalary = item.salaries.at(-1);
        if (lastSalary) {
          salary = lastSalary.salary;
          return true;
        }

        return false;
      });

      salaries.push({
        card_type_id: id,
        min_number,
        salary,
      });
    },
    handleDelete(index, { id, salaries }) {
      salaries.splice(index, 1);

      this.defaultCardTypes.some(item => {
        if (item.id !== id) return false;
        if (!item || !item.salaries || item.salaries.length === 0) return false;

        const lastSalary = item.salaries.at(-1);
        for (let i = 0;i < salaries.length;i++) {
          salaries[i].salary = item.salaries[i] ? item.salaries[i].salary : lastSalary.salary;
        }
        return true;
      });
    },
    async getList() {
      const { isError, data } = await getStoreTeacherLadderSalaries(this.storeId);
      if (isError) return;

      data.forEach(item => {
        item.salaries.forEach(salaryItem => {
          salaryItem.salary = dividedBy(salaryItem.salary, 100);
        })
      });

      this.cardTypes = data;
    },
    async getCardTypes() {
      const { isError, data } = await getStoreCardTypes();
      if (isError) return;

      data.forEach(item => {
        item.salaries.forEach(salaryItem => {
          salaryItem.salary = dividedBy(salaryItem.salary, 100);
        })
      });

      this.defaultCardTypes = data;
    },
    async handleSubmit() {
      if (this.isSaving) return;

      this.isSaving = true;

      const store_teacher_salaries = [];
      this.cardTypes.forEach(cardType => {
        cardType.salaries.forEach((item, index) => {

          if (index > 0 && item.min_number <= cardType.salaries[index - 1].min_number) return;

          const nextItem = cardType.salaries[index + 1];
          const max_number = nextItem && nextItem.min_number;
          store_teacher_salaries.push({
            card_type_id: cardType.id,
            salary: multipliedBy(item.salary, 100),
            min_number: item.min_number,
            max_number: max_number === undefined ? 99 : max_number,
          });

        });
      });

      const { isError } = await updateTeacherLadderSalaries({
        store_id: this.storeId,
        store_teacher_salaries,
      });
      this.isSaving = false;
      if (isError) return;

      this.$message.success('已成功保存薪资设置！');
      this.getList();
    },
  },
};
</script>

<style scoped src="./SalaryStage.css"/>
